export default {
  field: {
    margin: '.4rem .8rem',
  },
};
